var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComfortableHomeLazy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5d96d;}.cls-2{fill:#f5c160;}.cls-3{fill:#f0f4f7;}.cls-4{fill:#e0e9ee;}.cls-5{fill:#f6e782;}.cls-6{fill:#e5936b;}.cls-7{fill:#252b48;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Sofa Chair",
    id: "Sofa_Chair-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,34.35V20.46a3.82,3.82,0,0,0-3.82-3.83H11.82A3.82,3.82,0,0,0,8,20.46V34.35l7.2,8.86h33Z",
    id: "rect125298-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.35,16.63a3.82,3.82,0,0,1,3.82,3.83V34.35l-7.83,8.86h2.83L56,34.35V20.46a3.82,3.82,0,0,0-3.82-3.83Z",
    id: "path30777"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.25,37.6A3.26,3.26,0,0,0,44,34.35H20a3.26,3.26,0,0,0-3.26,3.25l-3.24,1.61.83,3.42,36.73.78-.42-3.2Z",
    id: "path81114-0-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.93,34.35v6.51h-29l.44,1.77,36.72.78-.42-3.2L47.24,37.6A3.25,3.25,0,0,0,44,34.35Z",
    id: "path22069"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.38,30A4.37,4.37,0,0,0,8,34.35V45.74a1.63,1.63,0,0,0,1.63,1.63H54.37A1.63,1.63,0,0,0,56,45.74V34.35a4.38,4.38,0,1,0-8.75,0v6.51H16.75V34.35A4.36,4.36,0,0,0,12.38,30Z",
    id: "rect78566-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.38,32.8a1.54,1.54,0,0,1,1.55,1.55v2.79a1.55,1.55,0,0,1-3.1,0V34.35A1.54,1.54,0,0,1,12.38,32.8Z",
    id: "rect79843-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.62,32.8a1.54,1.54,0,0,1,1.55,1.55v2.79a1.55,1.55,0,1,1-3.1,0V34.35A1.54,1.54,0,0,1,51.62,32.8Z",
    id: "path80646-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.62,30a4.1,4.1,0,0,0-1.32.21,4.37,4.37,0,0,1,3.05,4.17V45.74a1.63,1.63,0,0,1-1.63,1.63h2.65A1.63,1.63,0,0,0,56,45.74V34.35A4.37,4.37,0,0,0,51.62,30Z",
    id: "path28344"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M14.93,34.35a2.55,2.55,0,0,0-5.1,0v2.79a2.55,2.55,0,0,0,5.1,0Zm-2,2.79a.55.55,0,0,1-1.1,0V34.35a.55.55,0,1,1,1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.62,31.8a2.55,2.55,0,0,0-2.55,2.55v2.79a2.55,2.55,0,1,0,5.1,0V34.35A2.55,2.55,0,0,0,51.62,31.8Zm.55,5.34a.55.55,0,0,1-1.1,0V34.35a.55.55,0,1,1,1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.18,15.63H11.82A4.83,4.83,0,0,0,7,20.46V45.74a2.63,2.63,0,0,0,2.63,2.63H54.37A2.63,2.63,0,0,0,57,45.74V20.46A4.83,4.83,0,0,0,52.18,15.63ZM55,20.46v9.71A5.37,5.37,0,0,0,46.26,34,4.2,4.2,0,0,0,44,33.35H40.74V17.63H52.18A2.83,2.83,0,0,1,55,20.46ZM17.75,37.6A2.26,2.26,0,0,1,20,35.35H44a2.26,2.26,0,0,1,2.26,2.25v2.26H17.75Zm7.51-4.25V17.63H38.74V33.35ZM11.82,17.63H23.26V33.35H20a4.2,4.2,0,0,0-2.27.67A5.37,5.37,0,0,0,9,30.17V20.46A2.83,2.83,0,0,1,11.82,17.63ZM55,45.74a.63.63,0,0,1-.63.63H9.63A.63.63,0,0,1,9,45.74V34.35a3.38,3.38,0,1,1,6.75,0v5.51h-.46a1,1,0,0,0,0,2H48.71a1,1,0,0,0,0-2h-.46V34.35a3.38,3.38,0,1,1,6.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29,19.64h0a1.25,1.25,0,1,0,1.25,1.25h0A1.25,1.25,0,0,0,29,19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M35,19.64h0a1.25,1.25,0,1,0,1.25,1.25h0A1.25,1.25,0,0,0,35,19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.49,22.14a1.25,1.25,0,0,0,1.25-1.25h0a1.25,1.25,0,0,0-1.25-1.25h0a1.25,1.25,0,1,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.48,22.14a1.24,1.24,0,0,0,1.25-1.25h0a1.24,1.24,0,0,0-1.25-1.25h0a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.52,22.14a1.25,1.25,0,0,0,1.25-1.25h0a1.25,1.25,0,0,0-1.25-1.25h0a1.25,1.25,0,1,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.51,22.14a1.25,1.25,0,0,0,1.25-1.25h0a1.25,1.25,0,0,0-1.25-1.25h0a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29,24.67h0a1.25,1.25,0,1,0,1.25,1.25h0A1.25,1.25,0,0,0,29,24.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M35,24.67h0a1.25,1.25,0,1,0,1.25,1.25h0A1.25,1.25,0,0,0,35,24.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.49,24.67h0a1.25,1.25,0,1,0,1.25,1.25h0A1.25,1.25,0,0,0,44.49,24.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.48,27.17a1.24,1.24,0,0,0,1.25-1.25h0a1.24,1.24,0,0,0-1.25-1.25h0a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.52,27.17a1.25,1.25,0,0,0,1.25-1.25h0a1.25,1.25,0,0,0-1.25-1.25h0a1.25,1.25,0,1,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.51,27.17a1.25,1.25,0,0,0,1.25-1.25h0a1.25,1.25,0,0,0-1.25-1.25h0a1.25,1.25,0,0,0,0,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29,29.71h0A1.25,1.25,0,1,0,30.25,31h0A1.25,1.25,0,0,0,29,29.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M35,29.71h0A1.25,1.25,0,1,0,36.25,31h0A1.25,1.25,0,0,0,35,29.71Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfortableHomeLazy);
export default __webpack_public_path__ + "static/media/comfortable-home-lazy.b5a34e1888b092f32df24911df71684b.svg";
export { ForwardRef as ReactComponent };